import { useAtom } from 'jotai'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { showNotification } from '@/components/Notification'
import { qrCodesApi } from '@/generator/shared'

import { disableQrPasswordRequestAtom } from '../dialogsState'
import { patchQrPasswordInList } from '../qrPasswordListState'

export const useDisablePasswordRequest = () => {
	const t = useTranslations()
	const [request, setRequest] = useAtom(disableQrPasswordRequestAtom)

	useEffect(() => {
		if (!request) return
		setRequest(null)
		const disable = async () => {
			try {
				await qrCodesApi.deleteQrPassword(request.id)
				patchQrPasswordInList(request.id, false)
				showNotification(t('dashboard__qr_password__toast__disabled'), {
					type: 'success',
				})
			} catch (error) {
				console.error('Disabling QR password failed', error)
				showNotification(t('public__generic__unexpected_error'), {
					type: 'error',
				})
			}
		}
		disable()
	}, [request, setRequest, t])
}
